import { lazy, Suspense } from "react";

import { GenericCardLoader } from "@/web/routes/browse/-components/GenericCardLoader";
import type { BrowseResult } from "@/web/routes/browse/-components/types";

// The browse cards pull in a heavy tree (dialogs, pledge flows, charts). Split
// it into its own chunk so the map view doesn't load it until a pin's popup
// actually opens. `React.lazy` needs a default export, so re-export `BrowseCard`
// as one here.
const BrowseCard = lazy(() =>
  import("@/web/routes/browse/-components/cards/BrowseCard").then((m) => ({
    default: m.BrowseCard,
  })),
);

/** `BrowseCard` rendered behind a Suspense boundary so its chunk loads on demand. */
export function BrowseCardLazy({ result }: { result: BrowseResult }) {
  return (
    <Suspense fallback={<GenericCardLoader />}>
      <BrowseCard result={result} />
    </Suspense>
  );
}
